import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Image from './ui/Image';

class Videos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      video: this.props.selectedVideo.video
    };
  }
  getVideo(video) {
    return `./videos/${video}`;
  }
  getImage(img) {
    return `./imgs/${img}`;
  }
  openVideo(video) {
    // debugger;
    this.setState({ video: video });
  }
  render() {
    const { videos } = this.props;
    return (
      <div>
        <ul className="list">
          <li className="box-video">
            <video className="" controls key={this.state.video}>
              <source src={this.getVideo(this.state.video)} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </li>
        </ul>
        <ul className="container-mini list">
          <li className="row row--nowrap row--mini">
            {videos.map((video, i) => (
              <div className="col-2 cols-4--s" key={i}>
                <Image
                  onClick={() => this.openVideo(video.video)}
                  selected={this.state.video === video.video}
                  type="img-bg"
                  src={this.getImage(video.img)}
                  className="box-full img-hover"
                />
              </div>
            ))}
          </li>
        </ul>
      </div>
    );
  }
}

Videos.defaultProps = {};
Videos.propTypes = {
  images: PropTypes.array,
  selectedVideo: PropTypes.shape({})
};

export default Videos;



// WEBPACK FOOTER //
// ./src/components/Videos.jsx